import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import HomePage from "scenes/homePage";
import ProfilePage from "scenes/profilePage";
// import AuthPage from "scenes/logInSignUp";  // Unified login & signup
import ForgotPassword from "scenes/forgotPassword/forgotPass";
import AddPassword from "scenes/addPass/addPass";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { themeSettings } from "./theme";
import EmailVerify from "scenes/emailVerify";
import DiscoverTalents from "scenes/discover/Discover";
import MyUploads from "scenes/uploads/uploadedVideos";
import SavedVideos from "scenes/savedVids/savedVideos";
import Settings from "scenes/settings/settings";
import ProfPage from "scenes/profPage/ProfilePage";
import Upload from "scenes/upload/upload";
import SignUp from "scenes/logInSignUp/SignUp";
import Login from "scenes/logInSignUp/login";
import Post from "scenes/post/Post";
import HomeFeed from "scenes/homeFeed/HomeFeed";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
   const mode = useSelector((state) => state.mode);
   const safeMode = (mode && (mode.toLowerCase() === "light" || mode.toLowerCase() === "dark")) 
     ? mode.toLowerCase() 
     : "light"; // Default to light if invalid
   
   const theme = useMemo(() => createTheme(themeSettings(safeMode)), [mode]);
   // const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);
   const isAuth = Boolean(useSelector((state) => state.token));

   // console.log("Current mode:", mode);

   return (
      <div className="app">
         <BrowserRouter>
            <ThemeProvider theme={theme}>
               <CssBaseline />
               <Routes>
                  {/* Redirect root to /login */}
                  <Route path="/" element={<Navigate to="/login" />} />

                  {/* Public Routes (Accessible Without Login) */}
                  <Route path="/login" element={<Login />} />
                  <Route path="/signup" element={<SignUp />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/password-reset/:id/:token" element={<AddPassword />} />
                  <Route path="/users/:id/verify/:token" element={<EmailVerify />} />

                  {/* Protected Routes (Require Authentication) */}
                  <Route path="/home" element={isAuth ? <HomePage /> : <Navigate to="/login" />}>
                     <Route index element={<HomeFeed />} /> {/* This is your homepage content */}
                     <Route path="discover" element={<DiscoverTalents />} />
                     <Route path="uploads/:userId" element={<MyUploads />} />
                     <Route path="profile/:userId" element={<ProfPage />} />
                     <Route path="saved/:userId" element={<SavedVideos />} />
                     <Route path="settings" element={<Settings />} />
                     {/* New routes for posts and comments */}
                     <Route path="post/:postId" element={<Post />} /> {/* Handle individual post */}
                     <Route path="post/:postId/comments" element={<Post />} /> {/* Handle comments */}
                  </Route>

                  <Route path="/profile/:userId" element={isAuth ? <ProfPage /> : <Navigate to="/login" />} />
                  <Route path="/vid-upload/:userId" element={isAuth ? <Upload /> : <Navigate to="/login" />} />
                  
                  {/* Catch-all route (Redirect to auth if no match is found) */}
                  <Route path="*" element={<Navigate to="/login" />} />
               </Routes>
               <ToastContainer position="bottom-right" autoClose={3000} />
            </ThemeProvider>
         </BrowserRouter>
      </div>
   );
}

export default App;
